import { createAction } from 'redux-actions';

export const fetchAppResources = createAction('FETCH_APP_RESOURCES');
export const fetchAppResourcesSuccess = createAction('FETCH_APP_RESOURCES_SUCCESS');
export const fetchAppResourcesFailure = createAction('FETCH_APP_RESOURCES_FAILURE');

export const clearAppResourcesState = createAction('CLEAR_APP_RESOURCES_STATE');

export const deleteResources = createAction("DELETE_RESOURCES");
export const deleteResourcesSuccess = createAction("DELETE_RESOURCES_SUCCESS");
export const deleteResourcesFailure = createAction("DELETE_RESOURCES_FAILURE");

